import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Lesson1 from '../views/lesson1.vue'
import Lesson2 from '../views/lesson2.vue'
import Lesson3 from '../views/lesson3.vue'
import Lesson4 from '../views/lesson4.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },

  {
    path: '/lesson1',
    name: 'lessons1',
    component: Lesson1
  },

  {
    path: '/lesson2',
    name: 'lesson2',
    component: Lesson2
  },

  {
    path: '/lesson3',
    name: 'lesson3',
    component: Lesson3
  },

  {
    path: '/lesson4',
    name: 'lesson4',
    component: Lesson4
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    document.getElementById('app').scrollIntoView();
}
})

export default router
